module.exports = __webpack_public_path__ + "img/16_97.83b7ccea.png";